<template>
  <div>
    <h2>{{ data.title }}</h2>
    <p
      class="text-light"
      v-for="(paragraph, index) in data.paragraphs"
      :key="index"
    >
      {{ paragraph }}
    </p>
  </div>
</template>

<script>
export default {
  computed: {
    data() {
      return {
        title: "Need Help?",
        paragraphs: [
          "The customer service team is available Monday – Thursday from 8 AM to 6 PM ET and on Friday from 8 AM to 5 PM ET. You may call toll-free 1-855-920-3035 or email yourpassnow@egov.com."
        ]
      };
    }
  },
  name: "NeedHelp"
};
</script>
